import { EnvironmentInjector, inject, Injectable, Injector, runInInjectionContext } from "@angular/core";
import { ActivityVerbEnum } from "@shared/model/enum/activity-verb-enum";
import { INotifTextStrategy, Strategy } from "../model/notification.model";
import { NotificationStrategyMap } from "../constants/notification-strategy-map";
import { ActivityTextStrategy } from "../strategies/activity-text-strategy";


@Injectable({ providedIn: 'root' })
export class ActivityTextStrategyFactory {

    private injector = inject(EnvironmentInjector);

    private readonly strategyMap: Partial<Record<ActivityVerbEnum, Strategy>> = NotificationStrategyMap;


    /**
     * Returns the correct text strategy for the given activity verb.
     * Falls back to `ActivityTextStrategy` if no specific strategy is found.
     */
    public create(verb: ActivityVerbEnum): INotifTextStrategy {
        return runInInjectionContext(this.injector, () => {
            return inject(this.strategyMap[verb] ?? ActivityTextStrategy);
        });
    }

}
